import React, { Component } from 'react'
import * as components from '../../src/components'
import componentsData from './data/components'
import Demo from './components/Demo'
import IconDemo from './components/Icons'
import Button from '../../src/components/Button'
import AutoInput from './components/AutoInputSize'
import Icon from '../../src/components/Icon'
import styles from './Playground.css'

const initializeData = () => {
  // expose component list to UI
  window.componentList = Object.keys(components)
  window.componentList.forEach((component) => {
    // expose individual components for live coding
    window[component] = components[component]
  })

  // make component example data available for UI
  window.examples = {}
  componentsData.forEach((component) => {
    window.examples[component.name] = component
  })
}

const getHashLocation = () => window.location.hash.replace(/^#\/?|\/$/g, '').split('/')

export default class Playground extends Component {
  constructor (props, context) {
    super(props, context)
    initializeData()
    this.state = {
      component: getHashLocation(),
      loading: false,
      showProps: false,
    }
    // load the icon sprite into DOM
    Icon.loadSprite()
  }
  componentDidMount () {
    window.addEventListener('hashchange', this.handleNewHash, false)
  }
  componentDidUpdate () {
    initializeData()
  }
  handleNewHash = () => {
    const location = getHashLocation()
    this.setState({
      component: location
    })
  }
  showProps = () => {
    this.setState({
      showProps: !this.state.showProps
    })
  }
  renderSidebar () {
    const { component } = this.state

    const items = Object.keys(window.examples).map((comp, i) => {
      const classes = (comp === component[0]) ? styles.current : null

      return (
        <li key={i} className={classes}>
          <a href={`#${comp}`}>{comp}</a>
        </li>
      )
    })
    return (
      <ul className={styles.sidebarNavItems}>
        {items}
        <li>
          <a href={`#icons`}>All Icons</a>
        </li>
        <li>
          <a href={`#colors`}>All Colors</a>
        </li>
      </ul>
    )
  }
  renderExamples () {
    const { component } = this.state
    const examples = window.examples[component]
    if (!window.location.hash) {
      return (
        <div>
          <h1>Serverless UI Components</h1>
          <p>Welcome the the serverless component library, our <b>living style guide</b>.</p>
          <p>Your one stop shop for all UI components, colors, and icons.</p>
          <p>🎉🎉🎉🎉</p>
          <Button
            icon='github'
            href="https://github.com/serverless/platform/tree/master/frontend/src/components">
            View on Github
          </Button>
        </div>
      )
    }

    if (window.location.hash === '#icons') {
      return (
        <div style={{marginTop: 25}}>
          <IconDemo />
        </div>
      )
    }
    if (window.location.hash === '#colors') {
      return (
        <div style={{marginTop: 25}}>
          Coming soon...
        </div>
      )
    }
    if (!examples) {
      return <div style={{marginTop: 25}}>No examples found for {component}</div>
    }

    let description
    if (examples.description) {
      description = (
        <div dangerouslySetInnerHTML={{__html: examples.description}} />
      )
    }

    let props
    props = examples.props && Object.keys(examples.props).map((prop, i) => {
      const p = examples.props[prop]
      const isRequired = (p.required) ? <b>Required</b> : null

      let defaultValue
      if (p.defaultValue) {
        defaultValue = (
          <span className={styles.defaultValue}>Default: {p.defaultValue.value.replace(/'/g, '')}</span>
        )
      }
      let optionsRender
      if (p.type && p.type.name === 'enum' && typeof p.type.value === 'object') {
       const options = p.type.value.map((val, i) => {
         return (
          <span className={styles.allowedValues} key={i}>
            <AutoInput readOnly value={val.value.replace(/'/g, '')} />
          </span>
         )
       })
       optionsRender = (
         <div>
           <span className={styles.allowedValuesLabel}>Allowed Values:</span>
           {options}
         </div>
       )
     }
      const kind = (p.type && p.type.name) ? p.type.name : ''
      return (
        <div key={i} className={styles.propType}>
          <div className={styles.propTypeHeader}>
            <b className={styles.propName}>
              {prop}
            </b>
            <span className={styles.kind}>({kind})</span>
            -&nbsp;{p.description}
          </div>
          <div className={styles.propTypeDescription}>
            {isRequired}
            {optionsRender}
            {defaultValue}
          </div>
        </div>
      )
    })
    if (props) {
      props = (
        <div>

          <h3>Props</h3>
          {props}
        </div>
      )
    }

    const examplesRender = examples.examples.map((ex, i) => {
      return (
        <div key={`${component}-${i}`}>
          <Demo example={ex} name={component} />
        </div>
      )
    })

    const text = (this.state.showProps) ? 'Hide' : 'Show'
    return (
      <div className={styles.content}>
        <h1 className={styles.contentTitle}>&lt;{component} /&gt; Component
        <Button className={styles.propToggle} onClick={this.showProps}>
          {text} component propsTypes
        </Button>
        </h1>
        {description}

        {this.state.showProps && props}
        {examplesRender}
      </div>

    )
  }
  render () {
    return (
      <div className={styles.playground}>
        <div className={styles.sidebar}>
          <div className={styles.sidebarHeader}>
            <a href='/#' className={styles.logo}>
              <Icon name='logo' size={30} fill='#FD5750' />
              <div className={styles.logoWord}>UI Components</div>
            </a>
          </div>
          {this.renderSidebar()}
        </div>
        <div className={styles.contentWrapper}>
          {this.renderExamples()}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Playground.js